export default __webpack_public_path__ + "static/media/clip-light.d616dd8f.svg";